import { render, staticRenderFns } from "./DrawerMenuItems.vue?vue&type=template&id=2d089fb4&scoped=true&"
import script from "./DrawerMenuItems.vue?vue&type=script&lang=js&"
export * from "./DrawerMenuItems.vue?vue&type=script&lang=js&"
import style0 from "./DrawerMenuItems.vue?vue&type=style&index=0&id=2d089fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d089fb4",
  null
  
)

export default component.exports